import { FC, useCallback } from 'react';

import { BaseChips } from 'components/common/CompositeSelection/components/BaseChips';
import { useCompositeSelectionContext } from 'components/common/CompositeSelection/contexts';

interface CompositeSelectionChipsProps {
    containerDataQa: string;
    size?: 'small' | 'extra-small';
    title?: string;
}

const CompositeSelectionChips: FC<CompositeSelectionChipsProps> = ({ containerDataQa, size = 'small', title }) => {
    const { value, onChange } = useCompositeSelectionContext();

    const handleDelete = useCallback(
        (id: string) => {
            onChange((prev) => ({
                value: prev.value.filter((item) => item !== id),
                excludedValue: prev.excludedValue,
            }));
        },
        [onChange]
    );

    return (
        <BaseChips
            sourceValue={value}
            onDelete={handleDelete}
            containerId="included-chips-container"
            containerDataQa={containerDataQa}
            size={size}
            title={title}
        />
    );
};

export { CompositeSelectionChips };
